import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c37adb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-overlay" }
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = { class: "modal-body !tw-pt-0" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-body-text" }, " At iknowa, we are committed to resolving disputes efficiently and fairly. Our process promotes early resolution between parties while ensuring a transparent and structured approach to achieve a fair outcome when required. ", -1))
const _hoisted_5 = { class: "steps-list" }
const _hoisted_6 = { class: "step-icon" }
const _hoisted_7 = { class: "step-details" }
const _hoisted_8 = { class: "step-title" }
const _hoisted_9 = { class: "step-description" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "step-description"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_13 = { class: "tw-mb-4 tw-rounded-[8px] tw-border-[1px] tw-border-solid tw-border-[#DFDFDF] tw-bg-[#F8FBFD] tw-w-full tw-px-4 tw-py-5 tw-box-border tw-flex tw-flex-col tw-gap-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "next-steps" }, [
  /*#__PURE__*/_createTextVNode(" If the above aligns with your concerns, please proceed with a dispute. For more information for each phase please "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "details-link"
  }, "View Details"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))
const _hoisted_16 = { class: "modal-footer tw-flex tw-justify-end tw-gap-2 tw-pt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Text = _resolveComponent("Text")!
  const _component_GeneralDialog = _resolveComponent("GeneralDialog")!

  return (_openBlock(), _createBlock(_component_GeneralDialog, {
    class: "dispute-process-modal",
    isShowCloseButton: true,
    isShowHeader: true,
    descriptionColor: "#FAA100",
    isTitleStrong: true,
    headerTitle: "Dispute Process Overview",
    width: "570px",
    maxWidth: "100%",
    onOnClose: $setup.onClickCloseButton
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.steps, (step, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "step-item"
                }, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(step.number), 1),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("h3", _hoisted_8, _toDisplayString(step.title), 1),
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("p", null, _toDisplayString(step.description), 1)
                    ]),
                    (step.extra)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _hoisted_12,
                          _createElementVNode("p", null, _toDisplayString(step.extra), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_Text, {
                class: "!tw-text-[20px]",
                textWeight: "600"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Evidence Guide")
                ]),
                _: 1
              }),
              _createVNode(_component_Text, {
                variant: "span",
                textWeight: "600",
                lineHeight: "18px"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Please do not submit more than 5-10 images and files and be clear in your statement."),
                  _hoisted_14,
                  _createTextVNode(" Please view the example statement & evidence. "),
                  _createVNode(_component_Text, {
                    class: "!tw-underline !tw-cursor-pointer",
                    variant: "span",
                    textWeight: "600",
                    textColor: "#3B67E9",
                    lineHeight: "18px",
                    onClick: $setup.onOpenGuidanceModal
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Click Here")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _hoisted_15
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("button", {
          class: "button button-purple-border",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onClickCloseButton && $setup.onClickCloseButton(...args)))
        }, " Cancel "),
        _createElementVNode("button", {
          class: "button button-purple",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.onProceedWithDispute && $setup.onProceedWithDispute(...args)))
        }, " Proceed With A Dispute ")
      ])
    ]),
    _: 1
  }, 8, ["onOnClose"]))
}